import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useContentOverflow } from '../../../../hooks'
import { Counter, TABLE_VARIANT } from '../../../Counter'
import { FloatingTooltip } from '../../../Floating'
import { Skeleton } from '../../../Skeleton'
import Text from '../../../Text'
import { BirdviewCardDragHandle } from '../BirdviewCardDragHandle'

import * as styles from './BirdviewCardHeader.module.css'

function BirdviewCardHeader({
  TitleBefore = null,
  children,
  count,
  dragHandleProps,
  isAI,
  isLoading,
  title,
  titleBeforeProps,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [title],
  })

  return (
    <header className={styles.header}>
      <div className={styles.titleWrap}>
        {dragHandleProps && !isLoading ? (
          <BirdviewCardDragHandle dragHandleProps={dragHandleProps} />
        ) : null}
        {isLoading ? (
          <Skeleton className={styles.titleSkeleton} />
        ) : (
          <>
            {TitleBefore ? <TitleBefore {...titleBeforeProps} /> : null}
            <FloatingTooltip
              content={overflow ? title : null}
              placement={FLOATING_ELEMENT_PLACEMENT.top}
            >
              <Text
                Element='h2'
                className={classNames(styles.title, {
                  [styles.aiTitle]: isAI,
                })}
                ref={setContentOverflowRef}
              >
                {title}
              </Text>
            </FloatingTooltip>
            {count != null ? (
              <Counter count={count} variant={TABLE_VARIANT} />
            ) : null}
          </>
        )}
      </div>
      {children}
    </header>
  )
}

export default BirdviewCardHeader
